import { IBaseFilterParameter, BaseFilterParameter } from '../base-filter.parameter';

export interface IMemberParameter extends IBaseFilterParameter {
  key?: string;
  role?:  number[];
  team_roles?: number[];
  external_roles?: number[]
  current_filter?: 'team' | 'key' | 'external'
}

export class MemberParameter extends BaseFilterParameter {
  key?: string;
  role?: number[];
  team_roles?: number[]
  external_roles?: number[]
  current_filter?: 'team' | 'key' | 'external'

  constructor(partial: Partial<IMemberParameter> = {}) {
    super({ state: partial.state });
    Object.assign(this, partial);
  }
}


// WEBPACK FOOTER //
// ./src/models/profile/member.parameter.ts